import { useQuery } from '@tanstack/react-query'
import { fetchRoleCatalog } from './roles-api'

/** `GET api/roles/catalog`: every key a role can hold, with its label and grantable actions. */
export function useRoleCatalogQuery({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({ queryKey: ['roles', 'catalog'], queryFn: fetchRoleCatalog, enabled })
}
